<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Upload'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-card-button (action)="addAttachment()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/csv.svg'"
              style="width:20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="uploadButtonTitle" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'We can handle one or multiple files of any type.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    @if (attachments.length) {
      <tidy-row class="extra-bottom-padding">
        @for (attachment of attachments; track attachment; let i = $index) {
          <tidy-two-column-row>
            <tidy-text
              [body]="attachment.filename" />
            <tidy-text
              [actionBody]="'remove'"
              (action)="removeAttachment(i)"
              class="link red" />
          </tidy-two-column-row>
        }
      </tidy-row>
    }

    <form [formGroup]="itemForm" novalidate action="#">
      <tidy-row class="extra-bottom-padding">
        <tidy-textarea
          [label]="'Notes for Concierge (optional)'"
          [icon]="'assets/svg/create.svg'"
          [submitted]="submitted"
          [errorMessage]="'Please enter a description'"
          [form]="itemForm.get('body')"
          formControlName="body" />
      </tidy-row>
    </form>

    <tidy-button
      [text]="'Add Assets'"
      [action]="boundSaveItem"
      class="primary" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
